module.exports = __webpack_public_path__ + "img/zephyrusg14.d9420b9a.jpg";